<template>
  <div class="user-page">
    <navbarBox></navbarBox>
    <adduser></adduser>
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import adduser from "../components/adduser";
export default {
  name: "User",
  components: { navbarBox, adduser },
};
</script>

<style>
.user-page {
  height: 100%;
}
</style>